import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { Loader } from '@trendiolive/trendio-selfcare-ui-kit';
// project import
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'model/types/auth';
import { APP_DEFAULT_PATH } from 'constants/appConstants';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: Readonly<GuardProps>) {
  const { isLoggedIn, authInProgress, isRoleAttached, userRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn && !isRoleAttached) {
      navigate('/init', {
        state: {
          from: ''
        },
        replace: true
      });
    } else if (isLoggedIn && userRole) {
      navigate(location?.state?.from ? location?.state?.from : APP_DEFAULT_PATH, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, isRoleAttached, navigate]);

  if (authInProgress) return <Loader />;

  return children;
}
